import React, { useContext, useState } from "react";
import styles from "./Header.module.css";

function Header(props) {
  return (
    <>
      <div
        className={styles.heading + " " + props.className}
        style={{ ...props.style }}
      >
        {props.content || props.children}
      </div>
      {props.subheading && (
        <p className={styles.subheading}>{props.subheading}</p>
      )}
    </>
  );
}

export default Header;
